import { Breadcrumbs, usePageCrumbs } from '@platform/navigation';
import type { IRecordBreadcrumbsProps } from './IRecordBreadcrumbsProps';
import { recordCode } from './recordCode';
import { useTypeLabel } from './useTypeLabel';

/**
 * Крихти сторінки запису «Простір › Група › Модуль (› Таблиця) › Тип номер» (прототип v4: «… › Завдання › Завдання 101»; тип із полем
 * виду — вид запису: «Зацікавлена сторона 101»): підпис запису передається крихтам маршруту замість «КОД · Назва».
 */
export function RecordBreadcrumbs({ rt, record }: IRecordBreadcrumbsProps) {
  const singular = useTypeLabel(rt, record);
  const label = record ? `${singular} ${recordCode(record.display, record.code)}`.trim() : null;
  const crumbs = usePageCrumbs(label);
  return <Breadcrumbs items={crumbs} />;
}
